import React from "react";
import { Box, Table, TableBody, TableRow } from "@mui/material";
import {
  COLORS,
  SIZES,
  LabelCell,
  ValueCell,
  PhaseHeaderCell,
  PhaseDotCell,
  Dot,
  formatValueOrDash,
} from "../SkillSheetMainSectionUi";

/**
 * SkillSheetMainSummaryDesktop
 * PC表示用：横並びテーブルレイアウト
 */

/** 列幅定義（3ブロック構成） */
const COL_W = {
  // 左ブロック（40%）
  projectLabel: "10%",
  projectValue: "30%",

  // 中央ブロック（40%）
  scaleLabel: "8%",
  scaleValue: "12%",
  industryLabel: "8%",
  industryValue: "12%",

  // 工程（20% / 6列）
  phase: "3.333%",
};

export default function SkillSheetMainSummaryDesktop({
  workHistory,
  phases,
  displayValues,
  isPublicPage,
}) {
  return (
    <Box
      sx={{
        border: `1px solid ${COLORS.border}`,
        borderRadius: `${SIZES.radius}px`,
        overflow: "hidden",
        backgroundColor: COLORS.valueBg,
      }}
    >
      <Table
        sx={{
          tableLayout: "fixed",
          borderCollapse: "collapse",
          "& td, & th": { lineHeight: 1.4 },
        }}
      >
        {/* 列幅を固定するための colgroup */}
        <colgroup>
          <col style={{ width: COL_W.projectLabel }} />
          <col style={{ width: COL_W.projectValue }} />
          <col style={{ width: COL_W.scaleLabel }} />
          <col style={{ width: COL_W.scaleValue }} />
          <col style={{ width: COL_W.industryLabel }} />
          <col style={{ width: COL_W.industryValue }} />
          {phases.map((phase) => (
            <col key={phase.key} style={{ width: COL_W.phase }} />
          ))}
        </colgroup>

        <TableBody>
          {/* ===== 1行目：期間 ===== */}
          <TableRow>
            <LabelCell sx={{ borderLeft: "none" }}>期間</LabelCell>
            <ValueCell colSpan={6 + phases.length - 1}>
              {formatValueOrDash(displayValues.period)}
            </ValueCell>
          </TableRow>

          {/* ===== 2行目：基本情報 + 工程ヘッダー ===== */}
          <TableRow>
            <LabelCell sx={{ borderLeft: "none" }}>プロジェクト名</LabelCell>
            <ValueCell
              sx={
                isPublicPage
                  ? {
                      color: "transparent",
                      textShadow: "0 0 8px rgba(0,0,0,0.9)",
                      userSelect: "none",
                    }
                  : {}
              }
            >
              {formatValueOrDash(displayValues.name)}
            </ValueCell>

            <LabelCell>規模</LabelCell>
            <ValueCell>{formatValueOrDash(displayValues.scale)}</ValueCell>

            <LabelCell>業種</LabelCell>
            <ValueCell>{formatValueOrDash(displayValues.industry)}</ValueCell>

            {phases.map((phase) => (
              <PhaseHeaderCell key={phase.key}>{phase.label}</PhaseHeaderCell>
            ))}
          </TableRow>

          {/* ===== 3行目：役割 / 開発手法 + 工程ドット ===== */}
          <TableRow>
            <LabelCell sx={{ borderLeft: "none", borderBottom: "none" }}>
              役割
            </LabelCell>
            <ValueCell sx={{ borderBottom: "none" }}>
              {formatValueOrDash(displayValues.roles)}
            </ValueCell>

            <LabelCell sx={{ borderBottom: "none" }}>開発手法</LabelCell>
            <ValueCell colSpan={3} sx={{ borderBottom: "none" }}>
              {formatValueOrDash(displayValues.developmentMethods)}
            </ValueCell>

            {phases.map((phase) => {
              const isActive = !!workHistory.phasesActive?.[phase.key];
              return (
                <PhaseDotCell key={phase.key} sx={{ borderBottom: "none" }}>
                  {isActive ? <Dot active /> : null}
                </PhaseDotCell>
              );
            })}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}
